import React, { Component } from "react";
import ArticleBrow from "./ArticleBrow";
import ArticleItem from "../../../../components/Article/ArticleItem";
import ArticleLine from "../../../../components/Article/ArticleLine";
import { get } from "../../../../utils/request";
import "./style.css";
import "../../../../index.css";
class Article extends Component {
  constructor(...props) {
    super(...props);
    this.state = {
      dataSource: [],
      css: {
        article_shim: {
          height: 12,
        },
      },
    };
  }
  componentWillMount() {
    this.requestHomeArticle();
  }
  componentDidMount() {
    this.fixCss();
    window.addEventListener("resize", () => {
      this.fixCss();
    });
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this._resizeListener);
    clearTimeout(this.timeouter);
    this.setState = (state, callback) => {
      return;
    };
  }
  render() {
    const { dataSource } = this.state;
    //32个字
    return (
      <div className="article_box">
        {/* <div style={this.state.css.article_shim} className="article_shim"></div> */}
        {dataSource.map((item0, index) => {
          return (
            <div key={index}>
              <ArticleBrow title={item0.title} href={item0.href}></ArticleBrow>
              {item0.articleItems.map((item1, index) => {
                return (
                  <div key={index}>
                    <ArticleItem
                      title={item1.title}
                      hits={item1.hits}
                      titleImg={item1.titleImg}
                      articleType={item1.articleType}
                      hashId={item1.hashId}
                    ></ArticleItem>
                    <ArticleLine
                      visible={item0.articleItems.length !== index + 1}
                    ></ArticleLine>
                  </div>
                );
              })}
              <div
                style={this.state.css.article_shim}
                className={
                  dataSource.length === index + 1
                    ? "article_shim display_none"
                    : "article_shim"
                }
              ></div>
            </div>
          );
        })}
      </div>
    );
  }

  /**
   * 请求TopBanner的数据 type类型为1
   */
  requestHomeArticle() {
    get("/public/v1/home/module").then((res) => {
      this.setState({
        dataSource: res.data,
      });
    });
  }

  fixCss = () => {
    let clientWidth = document.body.clientWidth;
    let ratio = 1;
    if (clientWidth < 750) {
      ratio = clientWidth / 750;
    }
    this.setState({
      css: {
        article_shim: {
          height: 12 * ratio,
        },
      },
    });
  };
}

export default Article;



// WEBPACK FOOTER //
// ./src/containers/Home/components/Article/index.js